<!-- Directive for map background image with opacity of 0.2 -->
<background class="viewport-1" style="z-index: 1101;"></background>
<div class="congratulations-dialog" style="transition-duration: 2.0s"></div>